import { BorderRadius, Button } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface BackToAdvisorButtonProps {
  umbrellaUrlPath: string
}

export const BackToAdvisorButton = ({ umbrellaUrlPath }: BackToAdvisorButtonProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Button
      aria-label={t('navigation.back_to_advisor_view')}
      borderRadius={BorderRadius.R12}
      data-testid="back-to-advisor-button"
      href={umbrellaUrlPath}
      icon="arrowLeft"
      size="sm"
      variant="outlined"
    />
  )
}
